import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Container,
  Row,
} from "reactstrap";
import { useHistory } from "react-router-dom";

import { Link } from "react-router-dom";
import NkHeader from "./../../../common/nkheader";
import Form from "reactstrap/lib/Form";
import { createNewUserService } from "../../users/utils";
import { role } from "../../settings/manageuserVerification/utils";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";
import Loading from "../../loader/loader";

const Createuserheader = ({
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,

  handleFIlter,
}) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [roleName, setRoleName] = useState("");
  const [roleId, setRoleId] = useState([]);
  const [temp, setTemp] = useState(false);

  const [roleinfo, setRoleinfo] = useState(
    "357469b2-9f1d-418e-86d9-c7e53603060e"
  );

  const [createUserLoading, setCreateUserLoading] = useState(false);
  const history = useHistory();
  const [msg, setMsg] = useState(false);
  let regEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleEmail = (e) => {
    let data = e.target.value;
    if (regEmail.test(data) || data === "") setMsg(false);
    else setMsg(true);

    setEmail(data);
  };
  const handleUsername = (e) => {
    let data = e.target.value;
    console.log("data", data);
    setUsername(data);
    if (data.match(/^([a-zA-Z0-9.-]+)$/) || data === "") setTemp(false);
    else {
      setTemp(true);
    }
    setUsername(data);
  };

  const handleRole = (e) => {
    setRoleName(e.target.name);
    setRoleinfo(e.target.value);
  };

  useEffect(() => {
    var generator = require("generate-password");
    var pass = generator.generate({
      length: 6,
      numbers: true,
    });
    setPassword(pass);
  }, []);
  useEffect(() => {
    const RoleData = async () => {
      const roleData = await role();

      setRoleId(roleData);
    };
    RoleData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    createNewUser();
  };

  const createNewUser = () => {
    // request.size = sizeShow || 10;
    const requestObj = {
      email: email,
      username: username,
      password: password,
      roleId: roleinfo,
    };
    setCreateUserLoading(true);
    createNewUserService(requestObj)
      .then((res) => {
        setCreateUserLoading(false);
        console.log("new user response", res.data);

        history.push("/admin/ManageUsers");
        openNotificationWithIcon(
          notificationStrings.success,
          "User created successfully."
        );
      })
      .catch((err) => {
        setCreateUserLoading(false);
        history.push("/admin/ManageUsers");
      });
  };
  console.log("role", roleId);
  return (
    <>
      <Container fluid>
        <NkHeader title="Create new user" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="4" className="form-input-padding">
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Enter email address*
                    </label>
                    <Input
                      id="example3cols2Input"
                      placeholder={searchByValuePlaceholder}
                      type="text"
                      name="email"
                      value={email}
                      onChange={handleEmail}
                      placeholder="Enter your Email here.."
                    />
                    {msg ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "5px 0px",
                        }}
                      >
                        <text style={{ fontSize: "10px", color: "red" }}>
                          Enter Valid Email*
                        </text>
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Enter username*
                    </label>
                    <Input
                      id="example3cols2Input"
                      placeholder={searchByValuePlaceholder}
                      type="text"
                      name="username"
                      value={username}
                      onChange={handleUsername}
                      placeholder="Enter your username here.."
                    />
                    {temp ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "5px 0px",
                        }}
                      >
                        <text style={{ fontSize: "10px", color: "red" }}>
                          Special Characters are not allowed*
                        </text>
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Password*
                    </label>
                    {/* <div style={{ display: "flex", flexDirection: "column" }}>
                      <text style={{ fontSize: "10px", color: "gray" }}>
                        Must have atleast 6 characters
                      </text>
                    </div> */}
                    <Input
                      id="example3cols2Input"
                      type="text"
                      name="password"
                      value={password}
                      disabled={true}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Select Role
                    </label>
                    {roleId !== undefined && (
                      <Input
                        id="exampleFormControlSelect1"
                        type="select"
                        value={roleinfo}
                        onChange={handleRole}
                        name="Role"
                      >
                        {roleId.data &&
                          roleId.data.map((role) => (
                            <option value={role.id}>{role.name}</option>
                          ))}
                      </Input>
                    )}
                  </FormGroup>
                  <div>
                    <Link
                      to={{
                        pathname: "/settings/manageUserContent",
                      }}
                    ></Link>
                    <button
                      className="btn btn-primary mt-2"
                      type="submit"
                      disabled={
                        !email ||
                        !username ||
                        !role ||
                        msg ||
                        createUserLoading ||
                        temp
                      }
                    >
                      {createUserLoading ? (
                        <Loading color="white" width="15px" height="15px" />
                      ) : (
                        "Create New User"
                      )}
                    </button>
                  </div>
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Createuserheader;
